<template lang="pug">
ClientOnly
    UButton(
        size="xs" 
        variant="soft" 
        color="gray"
        :label="config.public.envName.toUpperCase()" 
        :icon="isDark ? 'heroicons:moon-20-solid' : 'heroicons:sun-20-solid'" 
        @click="isDark = !isDark"
        :trailing="true"
    )
</template>

<script setup lang="ts">
const colorMode = useColorMode()
const isDark = computed({
    get() {
        return colorMode.value === 'dark'
    },
    set() {
        colorMode.preference = colorMode.value === 'dark' ? 'light' : 'dark'
    },
})
const config = useRuntimeConfig()
</script>
